<template>
  <div class="api-doc-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="page-title">API开发文档</h1>
      <p class="page-subtitle">微信通知公共API接口文档</p>
    </div>

    <!-- 开发文档 -->
    <div class="section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="icon-doc"></i>
          开发文档
        </h2>
        <p class="section-desc">API接口使用说明与示例代码</p>
      </div>

      <div class="doc-card">
        <div class="doc-info">
          <h3 class="doc-title">微信通知-公共API文档</h3>
          <div class="doc-link-container">
            <span class="doc-link">{{ link }}</span>
            <div class="doc-actions">
              <button class="action-btn copy-link-btn" @click="copyLink">
                <i class="icon-copy"></i>
                复制链接
              </button>
              <button class="action-btn open-link-btn" @click="openLink">
                <i class="icon-external"></i>
                新窗口打开
              </button>
            </div>
          </div>
          <div class="doc-password">
            <span class="password-label">访问密码：</span>
            <span class="password-value">888888</span>
            <button class="copy-password-btn" @click="copyPassword">
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  async created() {},
  data() {
    return {
      activeList: [], // activeName，secret_key
      searchText: "", // 搜索关键词
      link: "https://docs.apipost.net/docs/65660e16d888000?locale=zh-cn",
      // 文案内容，供下载或复制使用
      txtContent: `客户获取数据的方式

方案1：客户主动拉取数据
您(客户方)通过我们的 API 文档编写代码查询并拉取数据。建议小程序数据根据时间筛选条件每分钟调用一次（定时任务），这样不会漏拉取也不会重复拉取，适合有研发能力并希望实时定期拉取的客户。

操作步骤请查看接口文档：https://docs.apipost.net/docs/detail/4efe1c1bf018000?target_id=3111ca5d339001
注意活动密钥secret_key为必填参数

方案2：WebHooks 实时推送
请联系我们后台运营配置接收数据地址（支持 http/https，自定义请求url地址，POST 请求）。当有用户登记时，系统会实时向该地址推送数据，您(客户方)仅需少量研发工作接收并处理数据即可。

接收参数格式请查看接口文档：https://docs.apipost.net/docs/detail/4efe1c1bf018000?target_id=3ddd51eb39000

方案3：人工处理
联系我们后台运营工作人员帮您开通账户，您自行登录下载数据。或者我们可以按约定周期将数据以表格形式（Excel/CSV）整理并发送给您。适用于不需实时接收且研发资源有限的场景。`
    };
  },
  computed: {
    // 根据搜索关键词过滤活动列表
    filteredActiveList() {
      if (!this.searchText.trim()) {
        return this.activeList;
      }
      const keyword = this.searchText.toLowerCase().trim();
      return this.activeList.filter(item => {
        const activeName = (item.activeName || "").toLowerCase();
        const secretKey = (item.secret_key || "").toLowerCase();
        return activeName.includes(keyword) || secretKey.includes(keyword);
      });
    }
  },
  methods: {
    // 复制Secret Key
    async copySecretKey(secretKey) {
      if (!secretKey) {
        this.$message.warning("该活动暂无密钥");
        return;
      }

      try {
        await this.copyToClipboard(secretKey);
        this.$message.success("密钥已复制到剪贴板");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制失败，请手动复制");
      }
    },

    // 复制文档链接
    async copyLink() {
      try {
        await this.copyToClipboard(this.link);
        this.$message.success("文档链接已复制到剪贴板");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制失败，请手动复制");
      }
    },

    // 复制密码
    async copyPassword() {
      try {
        await this.copyToClipboard("888888");
        this.$message.success("密码已复制到剪贴板");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制失败，请手动复制");
      }
    },

    // 新窗口打开链接
    openLink() {
      window.open(this.link, "_blank");
    },

    // 复制到剪贴板的通用方法
    async copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        // 使用现代 Clipboard API
        await navigator.clipboard.writeText(text);
      } else {
        // 降级方案：使用 document.execCommand
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          document.execCommand("copy");
        } finally {
          document.body.removeChild(textArea);
        }
      }
    },

    // 复制文案到剪贴板
    async copyTxt() {
      try {
        await this.copyToClipboard(this.txtContent);
        this.$message.success("文案已复制到剪贴板");
      } catch (error) {
        console.error("复制文案失败:", error);
        this.$message.error("复制失败，请手动复制");
      }
    },

    // 生成并下载 txt 文件
    downloadTxt() {
      try {
        const blob = new Blob([this.txtContent], {
          type: "text/plain;charset=utf-8"
        });
        const fileName = "客户获取数据方式.txt";
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE 10+
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error("下载 txt 失败:", error);
        this.$message.error("下载失败，请稍后重试");
      }
    }
  }
};
</script>

<style scoped lang="less">
/* 主题色定义 */
@primary-color: #165dff;
@primary-light: #4080ff;
@primary-dark: #0e42d2;
@text-primary: #2c3e50;
@text-secondary: #6c757d;
@background-light: #f8f9fa;
@border-color: #e9ecef;
@shadow-light: 0 2px 4px rgba(0, 0, 0, 0.1);
@shadow-medium: 0 4px 12px rgba(0, 0, 0, 0.15);

.api-doc-container {
  padding: 24px;
  background-color: #fff;
  max-height: 100vh;
  min-height: 100vh;
  overflow-y: scroll;
}

/* 页面标题区域 */
.page-header {
  text-align: center;
  padding: 32px 0;
  background: linear-gradient(135deg, @primary-color, @primary-light);
  border-radius: 12px;
  color: white;
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 8px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  color: white;
}

.page-subtitle {
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
}

/* 区块样式 */
.section {
  margin-bottom: 32px;
  background: white;
  border-radius: 12px;
  box-shadow: @shadow-light;
  overflow: hidden;
}

.section-header {
  padding: 24px 32px 16px;
  background: @background-light;
  border-bottom: 1px solid @border-color;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: @text-primary;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-desc {
  color: @text-secondary;
  margin: 0;
  font-size: 14px;
}

/* 图标样式 */
.icon-key::before {
  content: "🔑";
}
.icon-doc::before {
  content: "📚";
}
.icon-copy::before {
  content: "📋";
}
.icon-external::before {
  content: "🔗";
}
.icon-empty::before {
  content: "📭";
}

/* 搜索框样式 */
.search-container {
  padding: 16px 32px 0;
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-input {
  max-width: 400px;
}

.search-result-count {
  color: @text-secondary;
  font-size: 14px;
  white-space: nowrap;
}

/* 表格容器样式 */
.table-container {
  padding: 24px 32px;
}

.secret-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: @shadow-light;
}

/* 表格内容样式 */
.activity-name {
  font-weight: 500;
  color: @text-primary;
}

.secret-key-cell {
  display: flex;
  align-items: center;
}

.secret-text {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 13px;
  color: @text-primary;
  word-break: break-all;
  line-height: 1.4;
}

/* 表格复制按钮样式 */
.copy-btn-table {
  background-color: @primary-color !important;
  border-color: @primary-color !important;
  font-size: 12px;
  padding: 5px 10px;
}

.copy-btn-table:hover {
  background-color: @primary-dark !important;
  border-color: @primary-dark !important;
}

.copy-btn-table:disabled {
  background-color: #ccc !important;
  border-color: #ccc !important;
  cursor: not-allowed;
}

/* Element UI 表格样式覆盖 */
.secret-table .el-table__row:hover > td {
  background-color: @primary-light !important;
  background-color: rgba(22, 93, 255, 0.1) !important;
}

.secret-table .el-table__stripe {
  background-color: #fafafa;
}

.secret-table .el-table th {
  background-color: @primary-color !important;
}

.secret-table .el-table__empty-text {
  color: @text-secondary;
  font-size: 16px;
  text-align: center;
}

.secret-table .el-table__empty-block {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  width: 100% !important;
}

/* 文档卡片样式 */
.doc-card {
  padding: 32px;
}

.doc-info {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 12px;
  padding: 24px;
  border: 2px solid @border-color;
}

.doc-title {
  font-size: 18px;
  font-weight: 600;
  color: @text-primary;
  margin: 0 0 20px 0;
}

.doc-link-container {
  margin-bottom: 20px;
}

.doc-link {
  display: block;
  background: white;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid @border-color;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 14px;
  color: @primary-color;
  margin-bottom: 12px;
  word-break: break-all;
}

.doc-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
}

.copy-link-btn {
  background: @primary-color;
  color: white;
}

.copy-link-btn:hover {
  background: @primary-dark;
  transform: translateY(-1px);
}

.open-link-btn {
  background: #007bff;
  color: white;
}

.open-link-btn:hover {
  background: #0056b3;
  transform: translateY(-1px);
}

.doc-password {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid @border-color;
}

.password-label {
  font-weight: 600;
  color: @text-primary;
}

.password-value {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 16px;
  font-weight: bold;
  color: #dc3545;
  letter-spacing: 2px;
}

.copy-password-btn {
  background: @primary-color;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s ease;
}

.copy-password-btn:hover {
  background: @primary-dark;
}

/* 客户获取数据方式卡片样式 */
.fetch-methods-card {
  padding: 24px 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fetch-methods-card .method {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid @border-color;
}

.method-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: @primary-color;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
}

.method-body {
  flex: 1;
}
.method-title {
  margin: 0 0 6px 0;
  font-size: 16px;
  color: @text-primary;
}
.method-desc {
  margin: 0;
  color: @text-secondary;
  font-size: 14px;
  line-height: 1.6;
}

.method-actions {
  display: flex;
  gap: 12px;
  margin-top: 6px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .api-doc-container {
    padding: 16px;
  }

  .page-header {
    padding: 24px 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .section-header {
    padding: 16px 20px 12px;
  }

  .table-container {
    padding: 16px 20px;
  }

  .doc-card {
    padding: 20px;
  }

  .doc-actions {
    flex-direction: column;
  }

  .action-btn {
    justify-content: center;
  }

  /* 移动端表格样式调整 */
  .secret-table .el-table__body-wrapper {
    overflow-x: auto;
  }

  .copy-btn-table {
    font-size: 11px;
    padding: 4px 8px;
  }
}
</style>